import src from "IMAGE";
export default { src, width: 1215, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ALCwsG2tra5nqampZaysrWexsrJyqaqqZZ6enlOrq6tdQ84TLeUiv2MAAAAASUVORK5CYII="};
